import { render } from "./App.vue?vue&type=template&id=97015a8c&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=97015a8c&lang=css"
import "./App.vue?vue&type=style&index=1&id=97015a8c&scoped=true&lang=css"

import exportComponent from "/home/arjun/Documents/Projects/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97015a8c"]])

export default __exports__